import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ shape }) => ({
  root: {
    '& > button': {
      minWidth: 0,
      borderRadius: 0,

      '&:first-child': {
        borderTopLeftRadius: shape.borderRadius,
        borderBottomLeftRadius: shape.borderRadius,
      },

      '&:last-child': {
        borderTopRightRadius: shape.borderRadius,
        borderBottomRightRadius: shape.borderRadius,
      },
    },
    '& > *': {
      '& button': {
        borderRadius: 0,
        minWidth: 0
      },

      '&:first-child': {
        '& button': {
          borderTopLeftRadius: shape.borderRadius,
          borderBottomLeftRadius: shape.borderRadius,
        }
      },

      '&:last-child': {
        '& button': {
          borderTopRightRadius: shape.borderRadius,
          borderBottomRightRadius: shape.borderRadius,
        }
      },
    },
  }
}));
